<!--  -->
<template>
  <div class="">
    <BookDetail v-if="isEbook===1" :productDetail="productDetail" />
    <ProductDetail v-if="isEbook===0" />
  </div>
</template>

<script>
import { reqCourseDetailStreamline } from '../../api/courseDetail/index';
import BookDetail from './bookDetail.vue';
import ProductDetail from './productDetail.vue';
export default {
  components: {
    BookDetail,
    ProductDetail,
  },
  data() {
    return {
      courseId: this.$route.query.courseId,
      isEbook: -1,
      productDetail:{}
    };
  },
  computed: {},
  watch: {},
    beforeRouteEnter(to, from, next) {
    next(vm => {
      const param = sessionStorage.getItem('fromPageUrl')
        ? JSON.parse(sessionStorage.getItem('fromPageUrl'))
        : {};
      if (from.path === '/' && !sessionStorage.getItem('webLoadMode') === 'refresh') {
        // 判断专题页跳转
        param.fromPageUrl = '';
        param.fromPageUrlLast = document.referrer;
      } else if (!(from.path === '/' && sessionStorage.getItem('webLoadMode') === 'refresh')) {
        // 非刷新状态
        param.fromPageUrlLast = `${window.location.origin}${from.fullPath}`;
      }
      sessionStorage.setItem('fromPageUrl', JSON.stringify(param));
    });
  },
  methods: {
    // 获取课程基本信息
    async getCourseDetail() {
      const { data,currentTime } = await reqCourseDetailStreamline(this.courseId);
      const { isEbook } = data;
      this.productDetail=data;
      this.isEbook = isEbook;
      this.$store.dispatch('saveCourseBaseData', data);
      this.$store.dispatch('saveCourseDetailCurrentTime', currentTime);
    },
  },
  created() {},
  mounted() {
    this.getCourseDetail();
    this.$sendToApp('hiddenShareButton', { showShare: 1 }, false);
  },
  destroyed(){
    this.$sendToApp('hiddenShareButton', { showShare: 0 }, false);
  }
};
</script>
